import { render, staticRenderFns } from "./start-properties.vue?vue&type=template&id=905dda36&scoped=true"
import script from "./start-properties.ts?vue&type=script&lang=ts&external"
export * from "./start-properties.ts?vue&type=script&lang=ts&external"
import style0 from "./start-properties.less?vue&type=style&index=0&id=905dda36&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905dda36",
  null
  
)

export default component.exports